import lodash from 'lodash'
import Base from '../base.store'
import moment from "moment";
import { filter } from "../../../../utils/search";

const baseUrl = '/api/v1/master/pictogram'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cacheFindAll(context, { where = [], options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const sort = [{ name: "seq", type: "ASC" }];
            const list = context.state.list || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAll", { criteria: { select: ["*"] } }).then((list) => filter({ list, where, sort }));
        },
    },
    mutations: {
        ...base.mutations
    },
}
